import { useState, useEffect } from "react";

// Terminal-style typewriter reveal for mission-briefing headings.
export const Typewriter = ({ text, speed = 32, className = "", as: Tag = "span", showCursor = true }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    let i = 0;
    const id = setInterval(() => {
      i += 1;
      setCount(i);
      if (i >= text.length) clearInterval(id);
    }, speed);
    return () => clearInterval(id);
  }, [text, speed]);

  const done = count >= text.length;

  return (
    <Tag className={className}>
      {text.slice(0, count)}
      {showCursor && (
        <span
          className={`inline-block w-[0.5ch] -mb-0.5 ${done ? "animate-blink" : ""}`}
          style={{ color: "#D4AF37" }}
        >
          _
        </span>
      )}
    </Tag>
  );
};
